'use client';

import Icon from '@/components/ui/AppIcon';

const CollaborationCTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary/10 via-background to-secondary/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Main CTA Card */}
          <div className="bg-card border border-border rounded-2xl p-8 md:p-12 shadow-natural-lg text-center">
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-text-primary mb-4">
              Ready to Join Our Partnership Network?
            </h2>
            <p className="text-lg text-text-secondary mb-8 max-w-2xl mx-auto">
              Whether you're looking to implement sustainability solutions or become a strategic partner, GenCarbon's collaborative ecosystem provides the expertise and support you need.
            </p>

            {/* Contact Options */}
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              {[
                {
                  icon: 'DevicePhoneMobileIcon',
                  title: 'WhatsApp',
                  subtitle: 'Quick Response',
                  link: 'https://wa.me/919901503669?text=I%20want%20to%20explore%20partnership%20opportunities%20with%20GenCarbon',
                },
                {
                  icon: 'EnvelopeIcon',
                  title: 'Email',
                  subtitle: 'Detailed Inquiry',
                  link: 'tel:+919901503669',
                },
                {
                  icon: 'VideoCameraIcon',
                  title: 'Google Meet',
                  subtitle: 'Virtual Meeting',
                  link: 'https://meet.google.com/nupurbanker',
                },
              ]?.map((option, index) => (
                <a
                  key={index}
                  href={option?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-surface border border-border rounded-xl p-6 hover:shadow-natural-lg transition-all duration-300 ease-organic group"
                >
                  <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                    <Icon name={option?.icon} size={24} className="text-primary group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="font-heading font-bold text-text-primary mb-1 group-hover:text-primary transition-colors">
                    {option?.title}
                  </h3>
                  <p className="text-xs text-text-secondary">{option?.subtitle}</p>
                </a>
              ))}
            </div>

            {/* Primary CTA Button */}
            <a
              href="https://wa.me/919901503669?text=I%20want%20to%20explore%20partnership%20opportunities%20with%20GenCarbon"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-conversion text-conversion-foreground font-heading font-semibold text-lg rounded-xl hover:bg-conversion/90 shadow-natural hover:shadow-natural-lg transition-all duration-300 ease-organic transform hover:scale-105"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={24} />
              <span>Start Partnership Discussion</span>
            </a>
          </div>

          {/* Partnership Types */}
          <div className="mt-12 grid md:grid-cols-2 gap-6">
            <div className="bg-card border border-border rounded-xl p-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="BuildingOfficeIcon" size={20} className="text-primary" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-text-primary mb-2">
                    For Organizations
                  </h3>
                  <p className="text-sm text-text-secondary">
                    Looking to implement ESG solutions, carbon management, or sustainability reporting? 
                    Connect with our team for customized solutions.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-xl p-6">
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Icon name="UserGroupIcon" size={20} className="text-secondary" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-text-primary mb-2">
                    For Potential Partners
                  </h3>
                  <p className="text-sm text-text-secondary">
                    Bring complementary expertise to our network? Let's explore strategic 
                    collaboration opportunities to expand our collective impact.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollaborationCTASection;